import { trackEvent } from './trackEvent';

/** Playback failed after APIs succeeded — video error, iframe error, or embed submit failure. */
export function trackCctvStreamLoadFailed({ playerMode, message, endpoint, method } = {}) {
    trackEvent({
        category: 'cctv',
        title: 'Stream failed to load',
        message: message || 'Stream did not start — blank screen',
        endpoint: endpoint || 'cctv-stream',
        method,
        playerMode,
    });
}
